import React from 'react'

import Layout from 'components/common/Layout'
import Cover from 'components/artistsPage/Cover'

import * as SC from 'styles/artistStyles'

import useGetArtist from 'hooks/useGetArtist'
import { BreadcrumbJsonLd, NextSeo } from 'next-seo'
import { getFullPlace, getRusGenre, getSocials } from 'utils/personUtils'
import EmbedContent from 'components/common/EmbedContent'

const ArtistDetailPage = ({ currentArtist }) => {
  const artistInfo = useGetArtist(currentArtist.id)

  return (
    <Layout menuButtonColor={currentArtist.photo_site ? 'white' : 'black'}>
      <>
        <NextSeo
          title={`${currentArtist.name}`}
          description={`${currentArtist.description}`}
          canonical={`https://newopen.su/artists/${currentArtist.id}/${currentArtist.slug}`}
          openGraph={{
            url: `https://newopen.su/artists/${currentArtist.id}/${currentArtist.slug}`,
            title: `${currentArtist.name} | NEW / OPEN`,
            description: `${currentArtist.description}`,
            images: [
              {
                url: `${currentArtist.photo_site}`,
                width: 800,
                height: 600,
                alt: 'Artist page'
              }
            ]
          }}
        />
        <BreadcrumbJsonLd
          itemListElements={[
            {
              position: 1,
              name: 'Главная',
              item: 'https://newopen.su/'
            },
            {
              position: 2,
              name: 'Лекторий',
              item: 'https://newopen.su/artists'
            },
            {
              position: 3,
              name: `${currentArtist.name}`,
              item: `https://newopen.su/artists/${currentArtist.id}/${currentArtist.slug}`
            }
          ]}
        />
        <SC.ArtistPageWrapper isMarginTop={!artistInfo.data?.photoSite}>
          <Cover src="https://newopen.su/images/homePage/cover.png" srcMobile={artistInfo.data?.photoSite}>
            {artistInfo.data?.photoSite && (
              <div className="image-container desktop">
                <img src={artistInfo.data?.photoSite} alt={artistInfo.data?.name} />
              </div>
            )}
          </Cover>
          {artistInfo.data?.confirmed && <SC.WinnerIcon src="/svgs/winner.svg" />}
          {artistInfo.data?.name && <SC.ArtistName>{artistInfo.data?.name}</SC.ArtistName>}
          {artistInfo.data?.name && <SC.ArtistGenre>{getRusGenre[artistInfo.data?.genre]}</SC.ArtistGenre>}
          {artistInfo.data?.city && (
            <SC.ArtistCity>{getFullPlace(artistInfo.data?.country, artistInfo.data?.city)}</SC.ArtistCity>
          )}
          {artistInfo.data?.description && <SC.ArtistDescription>{artistInfo.data?.description}</SC.ArtistDescription>}
          {(artistInfo.data?.projectName || artistInfo.data?.projectDescription) && (
            <>
              <SC.ProjectTitle>Описание проекта</SC.ProjectTitle>
              <SC.Slash src="/svgs/slash.svg" />
              {artistInfo.data?.projectName && <SC.ProjectName>{artistInfo.data?.projectName}</SC.ProjectName>}
              {artistInfo.data?.projectDescription && (
                <SC.ProjectDescription>
                  {artistInfo.data?.projectDescription.split('\r\n').join('\r\n\r\n')}
                </SC.ProjectDescription>
              )}
            </>
          )}
          <SC.SocialIcons>
            {
              // artistInfo.data?.facebookUrl ||
              // artistInfo.data?.instagramUrl ||
              // artistInfo.data?.telegramUrl ||
              // artistInfo.data?.twitterUrl ||
              (artistInfo.data?.youtubeUrl ||
                artistInfo.data?.vkontakteUrl ||
                artistInfo.data?.tiktokUrl ||
                artistInfo.data?.rutubeUrl ||
                artistInfo.data?.maxUrl) && (
                <>
                  <SC.ProjectName>Социальные сети исполнителя:</SC.ProjectName>
                  <SC.SocialsRow>{getSocials(artistInfo.data)}</SC.SocialsRow>
                </>
              )
            }
          </SC.SocialIcons>
          {artistInfo.data?.playlistCode && (
            <SC.PlaylistWrapper>
              <SC.ProjectName>Творчество исполнителя:</SC.ProjectName>
              <EmbedContent content={artistInfo.data?.playlistCode} />
            </SC.PlaylistWrapper>
          )}
        </SC.ArtistPageWrapper>
      </>
    </Layout>
  )
}

export default ArtistDetailPage
